import '../styles/DashboardField.scoped.scss';

export default function NameEditor({name, onChange}) {
    const [editing, setEditing] = useState(false);

    const [newName, setNewName] = useState(name);

    const save = (e) => {
        onChange(newName);
        setEditing(false);
    }

    return <div>
        {editing && <div>
            <input type="text" value={newName} onChange={(e) => setNewName(e.target.value)} />
            <button className="button secondary" onClick={save}>Save</button>
        </div>}
        {!editing && <div className="flex items-center gap-10" onClick={() => setEditing(true)}>
            <h2>
                {name}
            </h2>
            <span className="edit-icon"><SvgIconsEdit color="currentColor" /></span>
        </div>}
    </div>
}